export const EarlyRequestKeys = {
  APP_INFO: 'app-info',
  FULL_APP_DETAILS: 'full-app-details',
  ACCOUNTS_LIST: 'accounts-list',
  APP_AUTHORIZATIONS: 'app-authorizations',
  SCOPE_GROUPS: 'scope-groups',
  INTERNALLY_DEVELOPED_APPS: 'internally-developed-apps'
};